import { PropTypes } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { actionTypes } from '@vooban/datagrid';
import DataGridReduxConnector from './DataGridReduxConnector';

const unsetScrollPosition = (pathname) => (dispatch) => {
  dispatch({
    type: actionTypes.UNSET_SCROLL_POSITION,
    payload: pathname,
  });
};

export const withReduxConnector = (component) => {
  const Wrapper = ({ searchParams: searchParamsFromProps, unsetScrollPosition: unsetScrollPositionProp, ...props }) => (
    <DataGridReduxConnector searchParams={searchParamsFromProps} storePath={props.storePath} withPresets={props.withPresets}>
      {(dataGridConnectorProps) => {
        return React.createElement(component, {
          ...props,
          ...dataGridConnectorProps,
          unsetScrollPosition: unsetScrollPositionProp,
        });
      }}
    </DataGridReduxConnector>
  );

  Wrapper.propTypes = {
    searchParams: PropTypes.instanceOf(URLSearchParams),
    withPresets: PropTypes.bool,
    storePath: PropTypes.string,
    unsetScrollPosition: PropTypes.func,
  };
  Wrapper.defaultProps = {
    searchParams: new URLSearchParams(),
    withPresets: false,
    storePath: undefined,
    unsetScrollPosition: () => undefined,
  };

  const ConnectedWrapper = connect(null, { unsetScrollPosition })(Wrapper);
  return ConnectedWrapper;
};
